import { css, cx } from '@eti/styles';
import type { ButtonHTMLAttributes } from 'react';
import { useEffect, useRef } from 'react';
import type { Modifiers } from 'react-day-picker';

const containerStyles = css`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  justify-content: center;
  padding: 0;
  position: relative;
  width: 100%;
`;

const dayNumberStyles = css`
  align-items: center;
  display: flex;
  height: 1.5rem;
  justify-content: center;
  text-align: center;
  width: 1.5rem;
`;

export interface PriceCalendarProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  date: Date;
  modifiers: Modifiers;
}

const CustomDayWithoutPriceIndicator = ({
  date,
  modifiers,
  ...buttonProps
}: PriceCalendarProps) => {
  const ref = useRef<HTMLButtonElement>(null);
  const { className, ...otherButtonProps } = buttonProps;

  useEffect(() => {
    if (modifiers.focused) {
      ref.current?.focus();
    }
  }, [modifiers.focused]);

  return (
    <button
      className={cx(className, containerStyles)}
      ref={ref}
      type="button"
      {...otherButtonProps}
    >
      <div className={dayNumberStyles}>{date.getDate()}</div>
    </button>
  );
};

export default CustomDayWithoutPriceIndicator;
